module.exports = __webpack_public_path__ + "img/noticebg.d92d3373.png";